import { Link } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IMAGE_ADDRESS } from '../../../../../../apis';



const CardOrder = (props) => {

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	
    	<Link to={`${props.data.uniqueCode}`} className={`bg-neutral-000 lg:rounded-medium text-neutral-500 flex flex-col items-stretch lg:border-complete-200 ${props.showBorderBottom ? 'border-complete-b-200' : ''}`}>
			<div className="py-5 lg:p-4 flex flex-col items-stretch gap-y-2 border-none lg:border-complete-b-200">
				<div className="flex items-start justify-between">
					<div className="flex flex-col">
						<div className="flex items-center text-body1-strong text-neutral-800">
							<div className="relative flex items-center lg:items-start self-stretch">
								<div className="relative">
									<div className="flex">
										{ props.data.status === 'delivered' &&
											<CheckCircleIcon sx={{fontSize: '24px', fill: 'var(--color-fresh-500)'}} />
										}
										{ props.data.status === 'pending' &&
											<HourglassBottomIcon sx={{fontSize: '24px', fill: 'var(--color-neutral-500)'}} />
										}
										{ props.data.status === 'shipped' &&
											<LocalShippingIcon sx={{fontSize: '24px', fill: 'var(--color-neutral-500)'}} />
										}
										{ props.data.status === 'canceled' &&
											<CancelIcon sx={{fontSize: '24px', fill: 'var(--color-hint-object-error)'}} />
										}
									</div>
								</div>
							</div>
							<div className="ml-2">{props.data.statusTxt}</div>
						</div>
					</div>
					<div>
						<div className="flex">
							<ChevronLeftIcon sx={{fontSize: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
						</div>
					</div>
				</div>
				<div className="hidden lg:flex items-center justify-start gap-1 gap-y-0">
					<div className="flex items-center">
						<div className="text-body-2 text-neutral-400"></div>
						<div className="text-body1-strong text-neutral-700 ml-1">
							<p className="text-body-1 text-neutral-500 mb-0">{toPersianDigits(props.data.registerDate)}</p>
						</div>
					</div>
					<div className="hidden lg:inline-block mx-1">
						<div className="flex">
							<FiberManualRecordIcon sx={{fontSize: '8px', fill: 'var(--color-icon-disable)'}} />
						</div>
					</div>
					<div className="flex items-center">
						<div className="text-body-2 text-neutral-400">کد سفارش</div>
						<div className="text-body1-strong text-neutral-700 ml-1">{toPersianDigits(props.data.uniqueCode)}</div>
					</div>
					<div className="hidden lg:inline-block mx-1">
						<div className="flex">
							<FiberManualRecordIcon sx={{fontSize: '8px', fill: 'var(--color-icon-disable)'}} />
						</div>
					</div>
					<div className="flex items-center">
						<div className="text-body-2 text-neutral-400">مبلغ</div>
							<div className="text-body1-strong text-neutral-700 ml-1">
								<div className="flex justify-start items-center">
									<div className="ml-1 text-subtitle-strong text-neutral-800">
										<div className="text-body1-strong">{toPersianDigits(props.data.productPrice)}</div>
									</div>
									<div className="">
									<div className="flex">
										ت
									</div>
								</div>
							</div>
						</div>
					</div>

					{ props.data.totalDiscount > '0' &&
					<>
					<div className="hidden lg:inline-block mx-1">
						<div className="flex">
							<FiberManualRecordIcon sx={{fontSize: '8px', fill: 'var(--color-icon-disable)'}} />
						</div>
					</div>
					<div className="flex items-center">
						<div className="text-body-2 text-neutral-400">تخفیف</div>
						<div className="text-body1-strong text-neutral-700 ml-1">
							<div className="flex justify-start items-center">
								<div className="ml-1 text-subtitle-strong text-neutral-800">
									<div className="text-body-1">{toPersianDigits(props.data.totalDiscount)}</div>
								</div>
								<div className="">
									<div className="flex">
										ت
									</div>
								</div>
							</div>
						</div>
					</div>
					</>
					}
				</div>
				<div className="flex lg:hidden items-center justify-start">
					<div className="flex items-center">
						<div className="text-body-2 text-neutral-400">کد سفارش</div>
						<div className="text-body1-strong text-neutral-700 mr-1">
							<div className="text-body1-strong">{toPersianDigits(props.data.uniqueCode)}</div>
						</div>
					</div>
				</div>
				<div className="flex lg:hidden items-center justify-between">
					<div className="flex items-center text-neutral-500 text-body-2">
						<div className="text-body-2 text-neutral-400">{toPersianDigits(props.data.registerDate)}</div>
						<div className="text-body1-strong text-neutral-700 ml-1"></div>
					</div>
					<div className="flex justify-start items-center text-neutral-900">
						<div className="ml-1 text-subtitle-strong text-neutral-800">
							<div className="text-body1-strong">{toPersianDigits(props.data.productPrice)}</div>
						</div>
						<div className="">
							<div className="flex">
								ت
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="grid grid-cols-7 lg:flex flex-col pb-5 lg:pb-0 ProfileNormalOrder-ProfileNormalOrder-productsContainer lg:border-complete-b-200">
				<div className="mx-4 lg:block ProfileNormalOrder-ProfileNormalOrder-contents">
					<div className="lg:grid grid-cols-8 py-4 gap-4 pb-4 ProfileNormalOrder-ProfileNormalOrder-contents">
						{ 
							props.data.products.map((product, key) => (
								<div key={`card-order-item-${key}`} className="lg:flex items-center justify-center w-full border-100">
									<div layout="fill" className="object-contain rounded ProfileNormalOrder-ProfileNormalOrder-product-images" style={{lineHeight: '0'}} >
										<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} alt="" title="" style={{objectFit: 'contain'}} />
									</div>
								</div>
							))
						}
					</div>
				</div>
			</div>
			{/*<div className="hidden lg:flex items-center justify-end py-3 px-4 text-secondary-500 text-body2-strong gap-6 gap-y-0">
				<a className="flex items-center text-body2-strong text-secondary-500 gap-2 py-2" data-cro-id="profile-see-factor" arget="blank" href="#!">
					<div className="flex">
						<ReceiptIcon sx={{fontSize: '20px', fill: 'var(--color-icon-secondary)'}} />
					</div>
					<span>مشاهده فاکتور</span>
				</a>
			</div>*/}
		</Link>

    );
}

export default CardOrder;